/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PreloadInputs */

const en_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preload`)
};

const fr_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préchargement`)
};

const de_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorladen`)
};

const it_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precarico`)
};

const ru_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительная загрузка`)
};

const es_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precarga`)
};

const zh_cn2_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预加载`)
};

const ja_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリロード`)
};

const hi_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीलोड`)
};

const pt_pt2_preload = /** @type {(inputs: PreloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-carga`)
};

/**
* | output |
* | --- |
* | "Preload" |
*
* @param {PreloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preload = /** @type {((inputs?: PreloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PreloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preload(inputs)
	if (locale === "de") return de_preload(inputs)
	if (locale === "it") return it_preload(inputs)
	if (locale === "ru") return ru_preload(inputs)
	if (locale === "es") return es_preload(inputs)
	if (locale === "zh-CN") return zh_cn2_preload(inputs)
	if (locale === "ja") return ja_preload(inputs)
	if (locale === "hi") return hi_preload(inputs)
	if (locale === "pt-PT") return pt_pt2_preload(inputs)
	return en_preload(inputs)
});